// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/bell.js';

import { paths } from '../generated/bell';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('bell', Original, paths);
